import { render, staticRenderFns } from "./x_covid19.vue?vue&type=template&id=69ce5c7f"
import script from "./x_covid19.vue?vue&type=script&lang=js"
export * from "./x_covid19.vue?vue&type=script&lang=js"
import style0 from "./x_covid19.vue?vue&type=style&index=0&id=69ce5c7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports